/* eslint-disable */
import { PureComponent, isValidElement, cloneElement } from 'react';
import invariant from 'invariant';

export default class ErrorBoundary extends PureComponent {
  state = { hasError: false, error: null, info: null };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.yarn add
    return { hasError: error };
  }

  getFallback = () => {
    const { fallback: ErrorHandlerComponent, ...rest } = this.props;
    const { error, info } = this.state;

    // return component
    return isValidElement(ErrorHandlerComponent)
      ? cloneElement(ErrorHandlerComponent, { error, info, ...rest })
      : null;
  };

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error, info });
    // You can also log the error to an error reporting service here
    invariant(error, error, info);
  }

  render() {
    const { hasError } = this.state;
    const { fallback, children } = this.props;

    if (hasError && fallback) {
      return this.getFallback();
    }

    return children;
  }
}
/* eslint-enable */
